import React from "react";
import Toolbar from "@mui/material/Toolbar";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";

export const SimpleSearch = React.memo(({ placeholder = "Pesquisar...", search, onChange }) => (
  <Toolbar>
    <TextField
      autoFocus
      name="search"
      variant="standard"
      placeholder={placeholder}
      value={search}
      onChange={onChange}
      sx={{ width: "100%" }}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon />
          </InputAdornment>
        ),
      }}
    />
  </Toolbar>
));
